import { render, staticRenderFns } from "./VulnerabilityList.vue?vue&type=template&id=20164034&"
import script from "./VulnerabilityList.vue?vue&type=script&lang=js&"
export * from "./VulnerabilityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20164034')) {
      api.createRecord('20164034', component.options)
    } else {
      api.reload('20164034', component.options)
    }
    module.hot.accept("./VulnerabilityList.vue?vue&type=template&id=20164034&", function () {
      api.rerender('20164034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/vulnerabilities/VulnerabilityList.vue"
export default component.exports